<template>
  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>

<script>

export default {
  name: 'App',
  computed: {
    layout(){
      return 'default-layout'
    }
  }
}
</script>

<style>
body{
  background: #fbfbfb;
  min-height: 100vh;
}
#app {
  font-family: 'Nunito', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
:root{
  --primary-color: #f26e0a;
  --secondary-color: #043367;
}
.navbar{
  background-color: var(--primary-color) !important;
  color: white !important;
}
.page-item.active > button{
  color: white !important;
  background-color: var(--secondary-color) !important;
  border-color: var(--secondary-color) !important;
}
.container-flex {
  display: flex;
  margin-bottom: 5px;
}
.column {
  flex: 1;
  padding-right: 25px;
  padding-left: 25px;
  box-sizing: border-box;
}
.page-item > button {
  color: #000000 !important;
  box-shadow: none !important;
}
.page-item:hover > button{
  background-color: var(--primary-color) !important;
  color: white !important;
  border-color: var(--primary-color) !important;
}
.br-2-blue{
  border: 2px solid var(--secondary-color) !important;
}
.btn-blue{
  background-color: var(--secondary-color) !important;
  color: #fff !important;
}
.form-control:focus {
  border-color: #f26e0a78 !important;
  box-shadow: 0 0 0 0.2rem rgba(242, 110, 10, 0.25) !important;
}

.loader {
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
}

.truckWrapper {
  width: 250px;
  height: 100px;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: flex-end;
  overflow-x: hidden;
}
/* truck upper body */
.truckBody {
  width: 130px;
  height: fit-content;
  margin-bottom: 6px;
  animation: motion 1s linear infinite;
}
/* truck suspension animation*/
@keyframes motion {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(3px);
  }
  100% {
    transform: translateY(0px);
  }
}
/* truck's tires */
.truckTires {
  width: 130px;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0px 15px;
  position: absolute;
  bottom: 0;
}
.truckTires svg {
  width: 24px;
}

.road {
  width: 100%;
  height: 1.5px;
  background-color: #282828;
  position: relative;
  bottom: 0;
  align-self: flex-end;
  border-radius: 3px;
}
.road::before {
  content: "";
  position: absolute;
  width: 20px;
  height: 100%;
  background-color: #282828;
  right: -50%;
  border-radius: 3px;
  animation: roadAnimation 1.4s linear infinite;
  border-left: 10px solid white;
}
.road::after {
  content: "";
  position: absolute;
  width: 10px;
  height: 100%;
  background-color: #282828;
  right: -65%;
  border-radius: 3px;
  animation: roadAnimation 1.4s linear infinite;
  border-left: 4px solid white;
}
.lampPost {
  position: absolute;
  bottom: 0;
  right: -60%;
  height: 90px;
  animation: roadAnimation 1.4s linear infinite;
}
.custom-control-label{
  cursor: pointer !important;
}
#modal-registro .modal-title {
  text-align: center !important;
  width: 100% !important;
}

@keyframes roadAnimation {
  0% {
    transform: translateX(0px);
  }
  100% {
    transform: translateX(-350px);
  }
}
@media only screen and (max-width: 767px) {
  .container-flex{
    flex-direction: column;
  }
}
</style>
